// @ts-nocheck
import fallbackImage from "@assets/images/fallback-image.svg";
import {useCallback} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {Carousel, HeadingCarousel} from "@/components";
import {useAuthStore} from "@/store/useAuth.store";
import useGetGameCarousels from "../../../../../../../hooks/useGetGameCarousels";

const promosContainerCls = "flex flex-col gap-10";
const carBoxConCls = "flex flex-col gap-5 mb-[60px] max-[426px]:mb-2.5";
const titBoxWraCls =
  "flex items-center justify-start gap-2.5 max-md:flex-col max-md:items-start max-md:justify-start max-md:px-5 max-[426px]:px-0";
const rulesButtonCls =
  "bg-[linear-gradient(135deg,var(--color-accent-purple-from)_0%,var(--color-accent-purple-to)_100%)] text-[var(--white)] border-0 rounded-lg px-4 py-2 text-sm font-semibold cursor-pointer transition-all duration-300 whitespace-nowrap shadow-[0_2px_8px_rgba(102,126,234,0.3)] hover:-translate-y-0.5 hover:shadow-[0_4px_12px_rgba(102,126,234,0.5)] hover:bg-[linear-gradient(135deg,var(--color-accent-purple-to)_0%,var(--color-accent-purple-from)_100%)] active:translate-y-0";
const carBoxWraCls = "flex flex-col gap-[200px]";
const gameCardCls =
  "bg-[var(--alternative-white)] flex items-center justify-center overflow-hidden rounded-2xl relative w-[var(--size-25)] h-[var(--size-25)] cursor-pointer transition-transform duration-200 hover:scale-105 [&_img]:w-full [&_img]:h-full [&_img]:object-cover";

export const GamePromos = () => {
  const {t} = useTranslation();
  const {promos} = useGetGameCarousels();
  const navigate = useNavigate();
  const authStatus = useAuthStore(state => state.authStatus);
  const handleShowAuthModal = useAuthStore(state => state.handleShowAuthModal);

  const handleGameClick = useCallback(
    game => {
      if (authStatus === "authenticated") {
        navigate(`/games/${game.provider}/${game.provider_game_id}`);
      } else {
        handleShowAuthModal();
      }
    },
    [authStatus, navigate, handleShowAuthModal]
  );

  // Handle image error with useCallback
  const handleImageError = useCallback(e => {
    e.target.onerror = null;
    e.target.src = fallbackImage;
  }, []);

  // Handle documentation link click
  const handleDocumentationClick = useCallback(url => {
    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  }, []);

  if (!promos.length) {
    return null;
  }

  return (
    <div
      id="gamesProm"
      className={promosContainerCls}
    >
      <HeadingCarousel
        title={t("dontMiss")}
        subtitle={t("dontMissTournaments")}
        icon="📢"
      />

      <div>
        {promos.map(promo => (
          <div
            key={promo.id}
            className={carBoxConCls}
          >
            <div className={titBoxWraCls}>
              <HeadingCarousel title={promo.title} />
              <button
                type="button"
                className={rulesButtonCls}
                onClick={() => handleDocumentationClick(promo.documentation_url)}
              >
                {t("tournamentRules")}
              </button>
            </div>

            <div className={carBoxWraCls}>
              <Carousel
                renderItems={(promo.games ?? []).map(game => (
                  <div
                    key={game.id}
                    className={gameCardCls}
                  >
                    {game.thumbnail_url && (
                      <img
                        src={game.thumbnail_url}
                        alt={game.name}
                        onError={handleImageError}
                        onClick={() => handleGameClick(game)}
                        loading="lazy"
                      />
                    )}
                  </div>
                ))}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
